import { FuelTypography, FuelButton } from '@frete.com/fuel-react'
import { Popover } from '~components'
import { PaginationsProps } from './interfaces'
import { useDeviceDetect, useTranslator } from '~hooks'
import { Text } from '~constants/text'

import * as Styled from './styled'
import { getCustomToken } from '~utils/token'

const Pagination = ({ currentPage, totalPages, onPageChange, noMargin }: PaginationsProps) => {
  const { isDesktop } = useDeviceDetect()
  const { translate } = useTranslator()

  return (
    <Styled.Wrapper noMargin={noMargin}>
      <FuelTypography tag="p" color="neutral-default" size="caption">
        {currentPage} {translate(Text.OF)} {totalPages}
      </FuelTypography>

      <Styled.PageDetailsWrapper>
        <Styled.CurrentPageWrapper>
          {isDesktop && (
            <FuelTypography tag="p" color="neutral-default" size="caption">
              {translate(Text.ON_THE_PAGE)}
            </FuelTypography>
          )}

          <Popover
            closeOnClick
            onTop
            direction="left"
            anchor={
              <FuelButton
                trailingIcon="arrow-dropdown"
                size="medium"
                variant="filter"
                data-testid="pagination-current-page"
              >
                {currentPage}
              </FuelButton>
            }
            content={
              <Styled.ListPaginationWrapper>
                {new Array(totalPages).fill('').map((_, i) => (
                  <Styled.Item
                    data-testid={`page-${i + 1}`}
                    key={getCustomToken()}
                    onClick={() => {
                      onPageChange(i + 1)
                    }}
                  >
                    <FuelTypography tag="p" color="neutral-default" size="body-sm">
                      {i + 1}
                    </FuelTypography>
                  </Styled.Item>
                ))}
              </Styled.ListPaginationWrapper>
            }
          />
        </Styled.CurrentPageWrapper>

        <Styled.ArrowsActionsWrapper>
          <FuelButton
            onlyIcon
            disabled={currentPage <= 1}
            onClick={() => {
              if (currentPage > 1) {
                onPageChange(currentPage - 1)
              }
            }}
            data-testid="pagination-previous-page"
            trailingIcon="arrow-left"
            variant="secondary"
            size="small"
          />
          <FuelButton
            onlyIcon
            disabled={currentPage >= totalPages}
            onClick={() => {
              if (currentPage < totalPages) {
                onPageChange(currentPage + 1)
              }
            }}
            data-testid="pagination-next-page"
            trailingIcon="arrow-right"
            variant="secondary"
            size="small"
          />
        </Styled.ArrowsActionsWrapper>
      </Styled.PageDetailsWrapper>
    </Styled.Wrapper>
  )
}

export default Pagination
